// src/admin/utils/kycStatus.ts — UI-side knowledge of the kyc_status enum.
// Used by the KYC queue, review screen, and borrower detail's KYC tab so
// label wording and tone stay consistent across every surface that shows
// a submission state.

import type { Database } from '@/lib/database.types';

type KycStatus = Database['public']['Enums']['kyc_status'];

export const KYC_STATUS_LABEL: Record<KycStatus, string> = {
  pending: 'Pending',
  manual_review: 'Manual review',
  verified: 'Verified',
  rejected: 'Rejected',
};

export const KYC_STATUS_TONE: Record<
  KycStatus,
  'neutral' | 'positive' | 'warn' | 'danger' | 'info'
> = {
  pending: 'neutral',
  manual_review: 'warn',
  verified: 'positive',
  rejected: 'danger',
};

// Pull the NRC number out of the OCR JSON blob. The kyc_submissions table
// does NOT have a top-level `nrc_number` column — the OCR provider writes
// an object into `ocr_result_jsonb` and the NRC lives there under `nrc_number`
// (per sub-project A's submit-kyc edge function contract).
export function nrcFromOcr(ocr: unknown): string | null {
  if (!ocr || typeof ocr !== 'object') return null;
  const v = (ocr as Record<string, unknown>)['nrc_number'];
  return typeof v === 'string' && v.length > 0 ? v : null;
}
